module.exports = __webpack_public_path__ + "static/media/clock.317dbc6f.svg";